
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payrollsystems/privacy-policy",
      function () {
        return require("private-next-pages/payrollsystems/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payrollsystems/privacy-policy"])
      });
    }
  